export const ChannelType = {
  PROGRAM: "program",
  PRIVATE: "messaging",
  BOX: "box",
} as const

export type ChannelType = (typeof ChannelType)[keyof typeof ChannelType]
